<template>
  <div class="integral-details">
    <div class="integral-details-main">
      <div class="top-title">
        <div class="top-title-left">
          <p class="customersName">客户名称：{{ customersName }}</p>
          <p>登录账号：{{ loginName }}</p>
        </div>
        <div class="top-title-right">
          <span>可使用积分：</span>
          <span class="integralVal">{{ integralVal }}</span>
        </div>
      </div>
      <div class="table" ref="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          ></el-table-column>
          <el-table-column
            label="积分值"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1 || scope.row.type === 3" style="display: inline-block; width: 10px;">+</span>
              <span v-else style="display: inline-block; width: 10px;text-align: center">-</span>
              <span>{{ scope.row.integralVal }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remarks"
            label="备注"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <pagination-tpl
          :total="total"
          :currentPage="page"
          :pageSize="pageSize"
          @queryChange="updatePage"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import Apply from "models/db/apply";
const apply = new Apply();
import PaginationTpl from "base/PaginationTpl";
import { formaTimeToSecond } from 'common/js/util.js';
const TYPE = {1:'获取', 2:'使用', 3: '充值', 4:'扣款', 5:'过期'}
export default {
  components: {
    PaginationTpl,
  },
  data() {
    return {
      xbPointsId: null,
      page: 1,
      total: 0,
      pageSize: 20,
      customersName: '',
      loginName: '',
      integralVal: null,
      tableData: [],
      tableTitle: [
        {label:'时间', prop: 'creatTime', width: ''},
        {label:'类型', prop: 'typeVal', width: ''},
      ]
    };
  },
  created() {
    this.$emit("childMueu", "积分中心", "明细", '/admin/apply/integral-content');
    this.xbPointsId = Number(this.$route.query.id)
    this.initIntegralDetails()
  },
  methods: {
    /* 翻页 */
    updatePage(data) {
      this.page = data.currentPage;
      this.initIntegralDetails();
    },
    /* 获取详情 */
    initIntegralDetails() {
      this.customersName = this.$route.query.xbName
      this.loginName =  this.$route.query.loginAccount
      this.integralVal = this.$route.query.pointsAvailable
      let xbPointsId = this.xbPointsId
      let currentPage = this.page
      apply.getPointsListDetails(xbPointsId, currentPage).then((res) => {
        if (res.success) {
          this.total = res.result.totalNum
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.creatTime = formaTimeToSecond(i.eventTime)
            obj.type = i.type
            obj.typeVal = TYPE[i.type]
            obj.integralVal = i.value
            obj.remarks = i.desc
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.integral-details {
  padding: 32px;
  flex: 1;
  overflow: auto;
  .integral-details-main {
    background: #fff;
    min-height: 100%;
    padding: 16px;
    box-sizing: border-box;
    .top-title {
      height: 78px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 4px;
      margin-bottom: 16px;
      padding-left: 31px;
      padding-right: 61px;
      background: #FFFFFF;
      border: 1px solid #eee;
      font-weight: 400;
      color: #666666;
      .top-title-left {
        font-size: 14px;
        .customersName {
          margin-bottom: 16px;
        }
      }
      .top-title-right {
        font-size: 24px;
        .integralVal {
          color: #3D74F2;
        }
      }
    }
    .page {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>